import { useState } from 'react';

// Use this when you want a reference to a value from a previous set of props or state.
// Tracks the previous value by adjusting state during render (React's recommended pattern):
// https://react.dev/reference/react/useState#storing-information-from-previous-renders
// We avoid the older useRef-in-effect approach because reading a ref during render is
// disallowed by the React Compiler.
export function usePrevious<T>(value: T): T | undefined {
  const [current, setCurrent] = useState(value);
  const [previous, setPrevious] = useState<T | undefined>(undefined);

  if (value !== current) {
    setPrevious(current);
    setCurrent(value);
  }

  return previous;
}
